import { useEffect, useState } from 'react';
import { liveQuery } from 'dexie';
import { db } from './db';

// Reactive map of entityId -> 'pending' | 'error' for every entity currently
// sitting in the sync queue, used to render per-row badges (section-div,
// room-div, equipment table rows) without polling.
export function usePendingSyncIds() {
    const [statusById, setStatusById] = useState({});

    useEffect(() => {
        const subscription = liveQuery(() => db.syncQueue.toArray()).subscribe({
            next: (rows) => {
                const next = {};
                for (const row of rows) {
                    // 'error' takes precedence over 'pending'/'in_flight' for the same entity
                    if (next[row.entityId] !== 'error') {
                        next[row.entityId] = row.status === 'error' ? 'error' : 'pending';
                    }
                }
                setStatusById(next);
            },
            error: (err) => console.error('Erreur de lecture de la file de synchronisation:', err),
        });
        return () => subscription.unsubscribe();
    }, []);

    return statusById;
}
